import * as React from "react"
import { cn } from "../../lib/utils"

interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
    /** 구분선 스타일: 'divide' (divide-x 사용) 또는 'border' (border 사용) */
    divider?: 'divide' | 'border' | 'none';
}

const ButtonGroup = React.forwardRef<
    HTMLDivElement,
    ButtonGroupProps
>(({ className, divider = 'none', ...props }, ref) => {
    const dividerStyles = {
        divide: "divide-x divide-gray-200",
        border: "-space-x-px [&>*]:border-r-0 [&>*:last-child]:border-r",
        none: ""
    };

    return (
        <div
            ref={ref}
            className={cn(
                "flex items-center border rounded-control-mobile lg:rounded-control overflow-hidden",
                dividerStyles[divider],
                // 자식 버튼들의 라운드 처리: 첫 번째/마지막만 라운드, 나머지는 사각형
                "[&>*]:rounded-none [&>*:first-child]:rounded-l-control-mobile lg:[&>*:first-child]:rounded-l-control [&>*:last-child]:rounded-r-control-mobile lg:[&>*:last-child]:rounded-r-control",
                // 자식 버튼들의 그림자 및 border 제거
                "[&>*]:shadow-none [&>*]:border-0",
                "[&>*:focus]:relative [&>*:focus]:z-10",
                className
            )}
            {...props}
        />
    )
})
ButtonGroup.displayName = "ButtonGroup"

export { ButtonGroup }
